import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Burger = forwardRef<SVGSVGElement, Partial<IconProps>>(function Burger({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="menu" description="open navigation menu" ref={ref} {...props}>
        <path {...stylex.props([iconsStyles.neutralElement])} d="M3 18h18v-2H3v2z" />
        <path {...stylex.props([iconsStyles.neutralElement])} d="M3 13h18v-2H3v2z" />
        <path {...stylex.props([iconsStyles.neutralElement])} d="M3 6v2h18V6H3z" />
      </Icon>;
});